import { getLevelColor } from "./riskMatrixLevel";

function escapeHtml(value) {
  return String(value ?? "").replace(/[&<>"']/g, (c) => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
  ));
}

function buildHeatmapHTML(items, t) {
  const counts = Array.from({ length: 5 }, () => Array(5).fill(0));
  items.forEach((item) => {
    const p = Number(item.probability);
    const s = Number(item.severity);
    if (p >= 1 && p <= 5 && s >= 1 && s <= 5) counts[s - 1][p - 1] += 1;
  });
  const rows = [5, 4, 3, 2, 1]
    .map((severity) => {
      const cells = [1, 2, 3, 4, 5]
        .map((probability) => {
          const level = probability * severity;
          const count = counts[severity - 1][probability - 1];
          return `<td style="background:${getLevelColor(level)};color:#fff;font-weight:700">${count > 0 ? count : ""}</td>`;
        })
        .join("");
      return `<tr><th>${severity}</th>${cells}</tr>`;
    })
    .join("");
  const axisRow = `<tr><th></th>${[1, 2, 3, 4, 5].map((p) => `<th>${p}</th>`).join("")}</tr>`;
  return `<table class="heat">${rows}${axisRow}</table>
    <p class="note" style="margin-top:6px">${escapeHtml(t("risk_matrix_severity"))} ↑ · ${escapeHtml(t("risk_matrix_probability"))} →</p>`;
}

function reportCSS() {
  return `
    body{font-family:Arial,Helvetica,sans-serif;color:#1A1C42;margin:0;background:#f5f8fb}
    header{background:#003872;color:#fff;padding:22px 30px}
    header .wm{font-family:Georgia,serif;letter-spacing:2px;font-size:12px;opacity:.85}
    header h1{margin:6px 0 0;font-size:22px}
    .wrap{max-width:960px;margin:0 auto;padding:26px 30px}
    .noprint{margin:0 0 18px}
    .noprint button{background:#003872;color:#fff;border:none;padding:9px 16px;border-radius:8px;font-weight:600;cursor:pointer}
    @media print{.noprint{display:none}}
    h2{font-size:16px;margin:22px 0 8px;color:#003872}
    .stat{display:inline-block;margin-right:18px;font-size:13px}
    .stat b{font-size:16px;display:block;color:#003872}
    .note{color:#5a6178;font-size:13px}
    table{border-collapse:collapse;font-size:12px}
    table.matrix{width:100%}
    table.matrix th,table.matrix td{border:1px solid #d5e2ef;padding:6px 8px;text-align:left}
    table.matrix th{background:#eef4fa}
    table.heat th,table.heat td{border:1px solid #d5e2ef;width:42px;height:36px;text-align:center;font-size:12px}
    table.heat th{background:#eef4fa;color:#003872}
    footer{border-top:1px solid #d5e2ef;margin-top:26px;padding:14px 30px;font-size:11px;color:#5a6178;display:flex;justify-content:space-between}
  `;
}

// Genera un reporte HTML descargable (imprimible/"guardar como PDF" desde el
// navegador) para una metodología — mismo espíritu que downloadReport() del
// prototipo, adaptado a los nombres de campo/columnas reales de cada modelo.
export function downloadRiskMatrixReport({
  t,
  filenamePrefix,
  tag,
  title,
  intro,
  statCount,
  statLabel,
  critCount,
  critLabel,
  oppCount,
  oppLabel,
  columns,
  sortedItems,
  items,
  hasHeatMap,
}) {
  const today = new Date().toISOString().slice(0, 10);
  const head = columns.map((c) => `<th>${escapeHtml(c.label)}</th>`).join("");
  const rows = sortedItems
    .map((item) => `<tr>${columns.map((c) => `<td>${escapeHtml(item[c.key])}</td>`).join("")}</tr>`)
    .join("");
  const heat = hasHeatMap ? `<h2>Heat map</h2>${buildHeatmapHTML(items, t)}` : "";

  const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"><title>Sustemia — ${escapeHtml(tag)}</title>
<style>${reportCSS()}</style></head>
<body>
<header><div class="wm">SUSTEMIA · MÓDULO AMBIENTAL</div><h1>${escapeHtml(tag)} — ${escapeHtml(title)}</h1>
<div style="font-size:12px;opacity:.9;margin-top:6px">Matriz de Aspectos e Impactos Ambientales · ${today}</div></header>
<div class="wrap">
<div class="noprint"><button onclick="window.print()">🖨 Imprimir / guardar como PDF</button></div>
<h2>Resumen</h2>
<div>
<span class="stat"><b>${statCount}</b>${escapeHtml(statLabel)}</span>
<span class="stat"><b>${critCount}</b>${escapeHtml(critLabel)}</span>
${oppCount != null ? `<span class="stat"><b>${oppCount}</b>${escapeHtml(oppLabel)}</span>` : ""}
</div>
<p class="note">${escapeHtml(intro)}</p>
<h2>Matriz</h2>
<div style="overflow-x:auto"><table class="matrix"><thead><tr>${head}</tr></thead><tbody>${rows}</tbody></table></div>
${heat}
</div>
<footer><span>SUSTEMIA</span><span>Reporte ${escapeHtml(tag)} · ${today}</span></footer>
</body></html>`;

  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `reporte_${filenamePrefix}_${today}.html`;
  a.click();
  URL.revokeObjectURL(url);
}
